import { useState } from "react";
import { Button } from "@/components/ui/button";
import { ConfirmReasonDialog } from "@/components/common/ConfirmReasonDialog";
import { Field, FormCard, ListState, Pick, patch, post, useList, useMembersByRole, useSubmit, AC } from "./shared";

const ClassEditor = ({ k, onClose }) => {
  const teachers = useMembersByRole(["guru", "wali_kelas"]);
  const students = useMembersByRole(["siswa"]);
  const [home, setHome] = useState(k.homeroom_membership_id || "");
  const [ids, setIds] = useState(k.student_membership_ids);
  const toggle = (id) => setIds(ids.includes(id) ? ids.filter((x) => x !== id) : [...ids, id]);
  return (
    <ConfirmReasonDialog open onOpenChange={(o) => !o && onClose()} title={`Atur kelas ${k.name}`} confirmLabel="Simpan kelas" testId="class-edit-dialog"
      onConfirm={(reason) => patch(`/classes/${k.id}`, { homeroom_membership_id: home || null, student_membership_ids: ids, reason }).then(onClose)}>
      <Pick label="Wali kelas" value={home} onChange={setHome} options={teachers.map((t) => ({ value: t.id, label: t.full_name }))} testId="class-homeroom-select" />
      <fieldset className="space-y-1 max-h-48 overflow-y-auto">
        <legend className="text-sm font-medium mb-1">Siswa di kelas ini</legend>
        {!students.length && <p className="text-xs text-muted-foreground">Belum ada anggota aktif berperan Siswa.</p>}
        {students.map((s) => (
          <label key={s.id} className="flex items-center gap-2 text-sm">
            <input type="checkbox" checked={ids.includes(s.id)} onChange={() => toggle(s.id)} data-testid={`class-student-${s.id}`} /> {s.full_name} {s.nisn && <span className="text-xs text-muted-foreground">NISN {s.nisn}</span>}
          </label>
        ))}
      </fieldset>
    </ConfirmReasonDialog>
  );
};

export const ClassesTab = ({ canManage }) => {
  const q = useList(`${AC}/classes`);
  const years = useList(`${AC}/years`);
  const s = useSubmit();
  const [f, setF] = useState({ academic_year_id: "", name: "", grade_level: "" });
  const [edit, setEdit] = useState(null);
  const add = () => s.run(() => post("/classes", f), "Kelas dibuat.").then((ok) => ok && setF({ ...f, name: "", grade_level: "" }));
  return (
    <div className="space-y-5">
      {canManage && (
        <FormCard title="Tambah kelas/rombel" onSubmit={add} busy={s.busy} err={s.err} submitLabel="Simpan" testId="class-form">
          <Pick label="Tahun ajaran" value={f.academic_year_id} onChange={(v) => setF({ ...f, academic_year_id: v })} options={(years.data || []).map((y) => ({ value: y.id, label: y.name }))} testId="class-year-select" />
          <Field id="c-name" label="Nama kelas (contoh VII-A)" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} data-testid="class-name-input" />
          <Field id="c-grade" label="Tingkat" value={f.grade_level} onChange={(e) => setF({ ...f, grade_level: e.target.value })} data-testid="class-grade-input" />
        </FormCard>
      )}
      <ListState q={q} empty={{ title: "Belum ada kelas", description: "Tambahkan kelas setelah tahun ajaran tersedia." }}>
        {(rows) => (
          <ul className="grid md:grid-cols-2 gap-4">
            {rows.map((k) => (
              <li key={k.id} className="rounded-2xl border bg-card p-5 space-y-2" data-testid={`class-${k.id}`}>
                <div className="flex items-start justify-between gap-2">
                  <div><p className="font-bold">{k.name}</p><p className="text-xs text-muted-foreground">Tingkat {k.grade_level}</p></div>
                  {canManage && <Button size="sm" variant="outline" onClick={() => setEdit(k)} data-testid={`class-edit-${k.id}`}>Atur</Button>}
                </div>
                <p className="text-sm"><span className="text-muted-foreground">Wali kelas:</span> {k.homeroom?.full_name || "Belum ditetapkan"}</p>
                <p className="text-sm"><span className="text-muted-foreground">Siswa ({k.students.length}):</span> {k.students.map((x) => x.full_name).join(", ") || "Belum ada"}</p>
              </li>
            ))}
          </ul>
        )}
      </ListState>
      {edit && <ClassEditor k={edit} onClose={() => { setEdit(null); q.refetch(); }} />}
    </div>
  );
};
